export default {
    name: "SVGMixin",
    props: {
        width: {
            type: Number,
            default: 50,
            required: false
        },
        height: {
            type: Number,
            default: 1,
            required: false
        }
    }
}